module.exports = __webpack_public_path__ + "static/media/sainikpic.71cc9aa3.JPG";